import { PageHeader } from "@/components/PageHeader/PageHeader";
import SplitLayout from "@/components/SplitLayout/SplitLayout";
import { useGetFacility } from "@/hooks/useFacilities";
import useTrackOnLoad from "@/hooks/useTrackPageview";
import useTranslation from "@/hooks/useTranslation";
import { useDashboardYear } from "@/pages/dashboard/hooks/useDateRange";
import useFacilityId from "../hooks/useFacilityId";
import { FacilityDetailsModeEnum } from "../types";
import Details from "./Details/FacilityDetails";
import styles from "./FacilityDetail.module.scss";
import Relations from "./Relations/FacilityRelations";
import Utilities from "./Utilities/Utilities";
import PublishFacility from "@/pages/facilities/detail/PublishFacility";
import { useCompanySettings } from "@/hooks/useCompanySettings";

export default function Facility() {
  useTrackOnLoad("Facility Viewed");

  const facilityId = useFacilityId();

  const { data: companySettings } = useCompanySettings();
  const { year } = useDashboardYear();
  const translation = useTranslation();

  const { data: facility, isLoading: utilityIsLoading } = useGetFacility(
    facilityId,
    !isNaN(facilityId)
  );

  return (
    <>
      <PageHeader
        title={facility?.facility_name}
        description={translation.facility.detail.pageDescription}
        loading={utilityIsLoading}
        right={
          <PublishFacility
            facilityId={facilityId}
            disabled={!facility?.address_is_valid}
          />
        }
      />
      <div className={styles.facility}>
        <SplitLayout
          left={
            <div className={styles.utilitiesContainer}>
              {year && (
                <Utilities
                  facilityId={facilityId}
                  year={year}
                  company_name={companySettings?.company_name}
                />
              )}
              <Relations />
            </div>
          }
          right={
            <Details
              mode={FacilityDetailsModeEnum.validate}
              key={facilityId}
            />
          }
        />
      </div>
    </>
  );
}
